import { DeckProps } from '@deck.gl/core/typed';
import { LngLatBoundsLike } from 'maplibre-gl';
import { ViewState } from 'react-map-gl/maplibre';
import { ContextMenuItem } from '../MapMarker';
import { Layer } from '@deck.gl/core/typed';
export interface BaseMapProps {
  toolbar?: boolean;
  searchBox?: boolean;
  entityDrawer?: React.ReactNode;
  mapContextMenu?: ContextMenuItem[];
  geometry?: any;
  bounds?: LngLatBoundsLike;
  showMapMarkers?: boolean;
  // TODO implement these props
  attributionControl?: boolean;
  className?: string;
  viewState?: Partial<ViewState>;
  contextChildren?: React.ReactNode;
  mapEntityClickEvents?: MapEntityClickEvent[];
  disableClusterSelection?: boolean;
  layers?: string[];
  trackMapSession?: boolean;
  previewLayers?: Layer[];
  /**
   * Components to render under the map libre map
   */
  mapChildren?: React.ReactNode;
  deckProps?: Partial<DeckProps>;

  layerButtonPosition?: 'top' | 'bottom';
  layerDrawerPosition?: 'left' | 'right';
  searchBoxPosition?: 'top-right' | 'bottom-right' | 'top-left' | 'bottom-left';
  zoomButtonsPosition?: 'top-right' | 'bottom-right' | 'top-left' | 'bottom-left';
  disableExtraLayerClicks?: boolean;
}

export enum MapEntityClickEvent {
  RIGHT = 'right',
  LEFT = 'left',
  CONTROL = 'control',
}
